import { useTokenUserData } from '@data/hooks';
import { Role } from '@data/sdk/match';

export const hasAllowedRole = (allowedRoles: Role[]): boolean => {
  const userData = useTokenUserData();
  const matches = allowedRoles.filter((role) => userData.roles.includes(role));
  return Boolean(matches.length);
};
